/* import __COLOCATED_TEMPLATE__ from './connect.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();